import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Support.module.scss';

export const SupportMainSection = () => (
  <AboutPageLayout
    isMain
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.mainSection_1}>
          Transparen <br /> <span>Terra</span>
        </div>
        <div className={styles.mainSection_2}>
          supports <br /> SDGs
        </div>
      </div>
    }
    rightContent={null}
  />
);
